import { useRouteError, isRouteErrorResponse } from 'react-router';
import Generic from './components/Generic';
import NotFound from './components/NotFound';

const ErrorPage = () => {
  const error = useRouteError();

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      return <NotFound />;
    }
  }

  return <Generic />
};

export default ErrorPage;
